import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Table, Tabs, Tooltip, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import BudgetTable from '../components/BudgetTable';
import useAnalyticAccountAPI from '../apis/analyticAccountAPI';
import useAnalyticPlan from '../apis/AnalyticPlanAPI';
import { ActionColumn } from '../utils/tableMockData';



const columns = [
  {
    title: 'Domain',
    dataIndex: 'domain',
    key: 'domain',
    className: 'text-wrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '10%'
  },
  {
    title: 'Financial Accounts Prefix',
    dataIndex: 'account_prefix',
    key: 'account_prefix',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '20%'
  },
  {
    title: 'Applicability',
    dataIndex: 'applicability',
    key: 'applicability',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '20%'
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
];

const domains = [
  {value: 'vendor_bill', label: 'Vendor Bill'},
  {value: 'invoice', label: 'Invoice'},
  {value: 'miscellaneous', label: 'Miscellaneous'},
  {value: 'sale_order', label: 'Sale Order'},
  {value: 'purchase_order', label: 'Purchase Order'}
];

const applicability = [
  {value: 'optional', label: 'Optional'},
  {value: 'mandatory', label: 'Mandatory'},
  {value: 'unavailable', label: 'Unavailable'}
]

const EditableCell = ({ editing, dataIndex, title, form, inputType, options, record, index, children, ...restProps }) => {
  const onChange = (option, form, dataIndex) => EventEmitter.dispatch('selected', {option, form, key:record.key, dataIndex});

  const inputNode = inputType === 'select' ? <Select style={{width: '140px'}} options={options} fieldNames={dataIndex} onChange={(value, option)=>onChange(option, form, dataIndex)}/> :
   <Input />;

    return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode}
        </Form.Item>
      ) : (
        // children
        <>{
            
            (inputType === 'select' && dataIndex === 'domain') ?
            form.getFieldValue(record.domain) :
            (inputType === 'select' && dataIndex === 'applicability') ?
            form.getFieldValue(record.applicability) :
            children 
          }</>
      )}
    </td>
  );
};

const AnalyticPlanChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {plan, plans } = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(plan.name ? plan.name : '');
  const [applicableLines, setApplicableLines] = useState(plan.applicables ? plan.applicables : []);
  const { save, update } = useAnalyticPlan();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    data['applicables'] = applicableLines;
    save(data, success);
    // console.log(data)
  }
  
  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    data['applicables'] = applicableLines;
    update(plan.seo, data, success);
    // console.log(data)
  }

  const edit = async (record) => {
      form.setFieldsValue({ ...record })
      setEditingKey(record.key)
    
  };

  const cancel = () => {
    setEditingKey('')
  }

  const handleSave = async (record) => {
    try {
      let key = record.key;
      const row = await form.validateFields();
      const newData = [...applicableLines];
      delete row.parent;
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row })
        console.log(newData)
        setApplicableLines(newData)
        setEditingKey('')
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }
  
  const addEntry = () => {
    let journalEntries_ = [...applicableLines]
    let entryObj = {
      key: applicableLines.length + 1,
      domain: '',
      account_prefix: '',
      applicability: ''
    }
    form.setFieldsValue({ ...entryObj });
    journalEntries_.push(entryObj)
    
    setApplicableLines(journalEntries_);
    setEditingKey(applicableLines.length + 1)
  }


  
  const removeEntry = (record) => {
    let key = record.key;
    let entries = applicableLines.filter((item) => item.key !== key)
    // entries.map((entryObj, index) => (entryObj['key'] = index))
    setApplicableLines(entries);
  }

  
  columns[columns.length - 1]['render'] = (_, record) =>
    ActionColumn(_, record, isEditing, handleSave, edit, cancel, removeEntry)

  // if (plan.seo)
  //   delete columns[columns.length - 1]['render']


  const onChangeName = e => setName(e.target.value);



  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
    ...col,
    onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      form: form,
      // selectedValue: selectedValue,
      inputType: (col.dataIndex === 'domain' || col.dataIndex === 'applicability') ? 'select' : 'text',
      options: 
        col.dataIndex === 'domain' && domains ||
        col.dataIndex === 'applicability' && applicability,
      editing: isEditing(record),
    }),
  }});
  
  useEffect(() => { 
    EventEmitter.subscribe('selected', data=> {
      const { option, form, key, dataIndex } = data;
      const { label, value } = option;
      form.setFieldValue(value, option.label);
    });

    EventEmitter.subscribe('analytic_plan_response', data => {
      navigate('/accounting/analytic-plans/'+data);
    });
    return () => { 
      EventEmitter.unsubscribe('selected');
      EventEmitter.unsubscribe('analytic_plan_response');
    }
  },[]);

  useEffect(() => {
    if (plan.applicables) {
      plan.applicables.forEach((item) => {
        let domain = domains.find((domain) => domain.value === item.domain);
        let applicable = applicability.find(applicable => applicable.value === item.applicability);
        form.setFieldValue(`${domain.value}`, `${domain.label}`);
        form.setFieldValue(`${applicable.value}`, `${applicable.label}`);
      })
    }
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/analytic-plans'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Analytic Plans</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ plan.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {plan.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3 shadow'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Plan Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 7}}
          initialValues={plan.seo ? {
            parent: plan.parent, } :
            {}}
          
        >
          <Row>
            <Col md={{span: 10}}>
              <Form.Item label='Parent' name={'parent'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={plans.map(plan => ({value: plan._id, label: plan.name}))} variant='borderless' className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Applicability',
                children: 
                  <Table
                    sticky
                    columns={mergedColumns}
                    dataSource={applicableLines}
                    components={{body: {cell: EditableCell}}}
                    rowClassName="editable-row"
                    pagination={false}
                  />
              },
            ]}
          />
          <Button onClick={addEntry}>Add Line</Button>
        </Form>
      </div>
    </div>
  )
}
export default AnalyticPlanChanges;